export default "__VITE_ASSET__CpUmu8OO__"